import { tileVariantOf } from "../../utilities/item-kinds";
import StampTile from "../HomePage/tiles/StampTile";
import CoverTile from "../HomePage/tiles/CoverTile";
import ArticleTile from "../HomePage/tiles/ArticleTile";

// True mosaic tile geometry (see MosaicGrid): a single tile renders at
// 235×300 on the capped 5-column homepage, a wide (2-col) tile at 486×300
const TILE_W = 235;
const TILE_H = 300;
const WIDE_W = 486;

function tileFor(item) {
  switch (item.kind) {
    case "cover":
      return <CoverTile item={item} />;
    case "article":
      return <ArticleTile item={item} />;
    default:
      return <StampTile item={item} />;
  }
}

// Live preview of the homepage mosaic tile, rendered with the real tile
// components so it can't drift from what the feed shows. Wide (2-column)
// tiles are drawn at full size and scaled down to the panel width.
export default function TilePreview({ formData, imageUrl }) {
  const item = {
    _id: "preview",
    kind: formData.kind,
    catalogue_id: formData.catalogue_id,
    subject: formData.subject,
    year: formData.year,
    image: imageUrl || "",
    description: formData.description,
    framing: formData.framing,
    tileVariant: formData.tileVariant,
    tileColor: formData.tileColor,
  };

  const variant = tileVariantOf(item);
  const isWide =
    (item.kind === "cover" && variant.startsWith("landscape")) ||
    (item.kind === "article" && variant === "wide");
  // Articles fall back to the text card without an image; stamps and
  // covers have nothing to show yet
  const missingImage = item.kind !== "article" && !imageUrl;

  const scale = isWide ? TILE_W / WIDE_W : 1;

  return (
    <div>
      <p className="text-sm font-bold text-ink/80 mb-2">
        Homepage tile preview
      </p>
      {missingImage ? (
        <div
          className="flex items-center justify-center rounded-md border border-dashed border-ink/25 bg-cream/50 px-6 text-center"
          style={{ width: TILE_W, height: TILE_H * scale }}
        >
          <p className="text-xs text-ink/40">
            Upload an image to preview the tile.
          </p>
        </div>
      ) : (
        // Clicks are swallowed before the tile's <Link> sees them, so the
        // preview keeps its hover behaviour without navigating anywhere
        <div
          onClickCapture={(evt) => evt.preventDefault()}
          style={{ width: TILE_W, height: TILE_H * scale }}
        >
          <div
            style={{
              width: isWide ? WIDE_W : TILE_W,
              height: TILE_H,
              transform: scale !== 1 ? `scale(${scale})` : undefined,
              transformOrigin: "top left",
            }}
          >
            {tileFor(item)}
          </div>
        </div>
      )}
      <p className="text-xs text-ink/40 mt-2">
        {isWide
          ? "Wide tile — spans two mosaic columns, scaled down to fit here."
          : "Shown at actual homepage size."}
      </p>
    </div>
  );
}
